<template>
  <div class="flexbox">
    <img
      class="box_img"
      src="@/assets/img/1x/communication-and-multimedia-info.svg"
      alt="Ícono multimedia"
      srcset=""
    />
    <p
      :data-obfuscate="quantumObfuscate"
      class="box_text_item"
      v-safe-html="text"
    ></p>
  </div>
</template>

<script>
export default {
  name: "Mancheta",
  props: {
    text: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
@media screen and (min-width: 600px) {
  .box_img {
    width: 30px;
    height: 30px;
    margin-top: 12px;
    margin-right: 10px;
  }

  .box_text_item {
    font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.6;
    letter-spacing: normal;
    color: #121212;
    width: 500px;
    text-align: left;
  }

  .flexbox {
    display: flex;
    justify-content: center;
    background: #d4edfc;
    flex-direction: row;
    width: 400px;
    padding: 20px 15px 15px 10px;
    margin-top: 50px;
  }
}
@media screen and (max-width: 600px) {
  .box_img {
    width: 30px;
    height: 30px;
    margin-top: 12px;
    margin-right: 10px;
  }

  .box_text_item {
    font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.6;
    letter-spacing: normal;
    color: #121212;
    width: 500px;
    text-align: left;
  }

  .flexbox {
    display: flex;
    justify-content: center;
    background: #d4edfc;
    flex-direction: row;
    width: 380px;
    margin-left: auto;
    margin-right: auto;
    padding: 20px 15px 15px 10px;
  }
}
</style>
